import { bool, object, func } from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _capitalize from 'lodash/capitalize';

import Form from 'ravenjs/lib/Form';
import { get } from 'ravenjs/utils/lodash';

import LoginFormActions from './LoginFormActions';
import LoginFormSchema from './LoginFormSchema.json';

const LoginFormContainer = styled.div`
    margin: 0 auto 50px;
    ${({ theme }) => theme.media.up('md')`
        width: 480px;
    `}
    input {
        width: 480px;
        height: 48px;
        font-size: 16px;
    }
    input[type='checkbox'] {
        width: 80px;
        height: 48px;
        font-size: 16px;
    }
`;

class LoginForm extends Component {
    static propTypes = {
        disabled: bool,
        /**
         * Initial `formData`
         */
        formData: object,
        /**
         * Callback fired when the form is ready to be submitted.
         *
         * @param {object} formData The current formData
         */
        onSubmit: func,
        /**
         * If `true`, the form will be marked as read-only.
         */
        readonly: func,
    };

    static defaultProps = {
        disabled: false,
        formData: null,
        onSubmit: null,
        readonly: null,
    };

    constructor(props) {
        super(props);

        const { formData } = props;
        const username = localStorage.getItem('remember_username');
        const updatedFormData = {};
        if (username) {
            updatedFormData.username = username;
        }

        this.state = {
            formData: {
                ...formData,
                rememberUsername: !_isEmpty(localStorage.getItem('remember_username')),
                ...updatedFormData,
            },
        };
    }

    onFormSubmit = ({ formData }) => {
        const { onSubmit } = this.props;

        if (typeof onSubmit === 'function') {
            onSubmit({ formData });
        }

        this.setState(() => ({ formData }));
    };

    transformErrors = errors => {
        return errors.map(error => {
            const name = get(error, 'name');
            const missingProperty = get(error, 'params.missingProperty');
            if (name === 'required') {
                error.message = `${_capitalize(missingProperty)} is a required field.`;
            }
            return error;
        });
    };

    transformDataIn = formData => {
        if (!_isEmpty(formData)) {
            return {
                ...formData,
                userCreds: {
                    username: _get(formData, 'username'),
                    password: _get(formData, 'password'),
                    rememberUsername: _get(formData, 'rememberUsername'),
                },
            };
        }

        return {};
    };

    transformDataOut = formData => {
        const copy = { ...formData };

        if (!_isEmpty(formData)) {
            delete copy.userCreds;
            return {
                ...copy,
                ...formData.userCreds,
            };
        }

        return {};
    };

    render() {
        const { formData } = this.state;
        const { disabled, readonly } = this.props;

        return (
            <LoginFormContainer>
                <Form
                    {...LoginFormSchema}
                    disabled={disabled}
                    disableActions
                    formData={formData}
                    onSubmit={this.onFormSubmit}
                    readonly={readonly}
                    transformErrors={this.transformErrors}
                    transformDataIn={this.transformDataIn}
                    transformDataOut={this.transformDataOut}
                    showErrorList={false}
                >
                    <LoginFormActions disabled={disabled} />
                </Form>
            </LoginFormContainer>
        );
    }
}

export default LoginForm;
